import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Table, {TableCell, TableRow, TableSectionHeader} from "@amzn/meridian/table";
import React, {useContext} from "react";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close";
import check from "@amzn/meridian-tokens/base/icon/check-large"
import {CartDetailContext} from "./context/CartDetailContext";
import {FormattedMessage} from "react-intl";

const CartContent = () => {
    const {viewModel} = useContext(CartDetailContext)
    return (
        <div>
            <Row widths="100%" spacingInset="large large small">
                <Heading level={3} type="h500" alignment="left">{viewModel.name}</Heading>
            </Row>
            <Row widths={["grid-7"]} spacingInset="small large small">
                <Table headerRows={1}
                       showDividers={false}
                       headerColumns={1}
                       fixHeaderRows={true}
                       stickyHeaderColumn={true}
                       stickyHeaderRow={true}
                       spacing="small">
                    <TableRow>
                        <TableCell/>
                        <TableCell>
                          <FormattedMessage id="cartContent.location" defaultMessage="Location"/>
                        </TableCell>
                        <TableCell>
                            <FormattedMessage id="cartContent.picked" defaultMessage="Picked"/>
                        </TableCell>
                        <TableCell>
                            <FormattedMessage id="cartContent.staged" defaultMessage="Staged"/>
                        </TableCell>
                        <TableCell>
                            <FormattedMessage id="cartContent.departed" defaultMessage="Departed"/>
                        </TableCell>
                    </TableRow>
                    {viewModel.bags.length > 0 ? (
                        <TableSectionHeader>
                            <FormattedMessage id="cartContent.bags" defaultMessage="Bags"/>: {viewModel.bags.length}
                        </TableSectionHeader>
                    ) : null}
                    {viewModel.bags.map(bag => (
                        <TableRow key={bag.label}>
                            <TableCell>{bag.label}</TableCell>
                            <TableCell>{bag.location}</TableCell>
                            <TableCell>
                                <Text>
                                    {bag.picked ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/> }
                                </Text>
                            </TableCell>
                            <TableCell>
                                <Text>
                                    {bag.staged ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/> }
                                </Text>
                            </TableCell>
                            <TableCell>
                                <Text>
                                    {bag.departed ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/> }
                                </Text>
                            </TableCell>
                        </TableRow>
                    ))}
                    {viewModel.packages.length > 0 ? (
                        <TableSectionHeader>
                            <FormattedMessage id="cartContent.packages" defaultMessage="Packages"/>: {viewModel.packages.length}
                        </TableSectionHeader>
                    ) : null}
                    {viewModel.packages.map(packages => (
                        <TableRow key={packages.label}>
                            <TableCell>{packages.label}</TableCell>
                            <TableCell>{packages.location}</TableCell>
                            <TableCell>
                                <Text>
                                    {packages.picked ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/> }
                                </Text>
                            </TableCell>
                            <TableCell>
                                <Text>
                                    {packages.staged ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/> }
                                </Text>
                            </TableCell>
                            <TableCell>
                                <Text>
                                    {packages.departed ? <Icon className="picked-success" tokens={check}/> :
                                        <Icon className="picked-failed" tokens={closeMediumTokens}/> }
                                </Text>
                            </TableCell>
                        </TableRow>
                    ))}
                </Table>
            </Row>
        </div>
    )
}

export default CartContent



// WEBPACK FOOTER //
// ./src/components/cartDrillDown/CartContent.js